module.exports = __webpack_public_path__ + "images/ca27047ae8b3e1b8d4a9a387cb5cab84.svg";